import theme from '@/style';
// import LazyImage from '@/components/basic/image';
import {Image as LazyImage} from 'antd-mobile';
import {goTo} from '@/utils';
import React, {useState, useCallback} from 'react';
import {View, Image, Text, Pressable} from 'react-native';
import {useInnerStyle} from '../home.hooks';
import {useTranslation} from 'react-i18next';
import {useLuckySpinModal} from '@/common-pages/luckyspin/luckyspin.hooks';
import globalStore from '@/services/global.state';
import {postSpinConfig} from '@/common-pages/luckyspin/luckyspin.service';
// import {homePage} from '@/config';
import {useFocusEffect} from '@react-navigation/native';
// import {Swiper, SwiperSlide} from 'swiper/react';
import {useScreenSize} from '@/common-pages/hooks/size.hooks';
import {toAllCasinoGame} from '@/common-pages/game-navigate';
// import {openPick11} from '../pick11-navigate';
// import {toPriceStr} from '@/components/utils/converter';

const HomeGoldArea: React.FC = () => {
  const {i18n} = useTranslation();
  const {
    size: {screenWidth},
  } = useInnerStyle();
  const {calcActualSize} = useScreenSize();
  // gold-area: Pick11 / Cricket / Casino / Live / Spin / Aviator
  const list = [
    // {
    //   bgImgUrl: require('@/assets/imgs/home/pick11.webp'),
    //   moduleName: 'Pick 11',
    //   jumpHandler() {
    //     openPick11();
    //   },
    // },
    {
      bgImgUrl: require('@/assets/imgs/home/cricket1.webp'),
      moduleName: i18n.t('home.label.cricket'),
      jumpHandler() {
        globalStore.openSports.next('/cricket');
      },
    },
    {
      bgImgUrl: require('@/assets/icons/home/casino.webp'),
      moduleName: 'Casino',
      jumpHandler() {
        goTo('Casino');
      },
    },
    {
      bgImgUrl: require('@/assets/icons/home/live.webp'),
      moduleName: 'Live',
      jumpHandler() {
        goTo('LiveCasino');
      },
    },
    {
      bgImgUrl: require('@/assets/imgs/home/spin1.webp'),
      moduleName: i18n.t('home.label.spin'),
      jumpHandler() {
        if (!token) {
          goTo('Login');
          return;
        }
        spinShow();
      },
    },
    {
      bgImgUrl: require('@/assets/imgs/home/aviator1.webp'),
      moduleName: i18n.t('home.label.aviator'),
      jumpHandler() {
        if (process.env.NODE_ENV === 'production') {
          toAllCasinoGame(32152);
        } else {
          toAllCasinoGame(38681);
        }
      },
    },
  ];
  const DISIGN_WEIDTH = 375;
  const computedSize = (num: number) => (num * screenWidth) / DISIGN_WEIDTH;
  const size = {
    computedL: computedSize(theme.paddingSize.l),
    computedS: computedSize(theme.paddingSize.s),
    computed60: computedSize(56),
    computed44: computedSize(44),
    computed40: computedSize(40),
    computed36: computedSize(36),
  };
  const [drawImage, setDrawImage] = useState<string>();
  const [spinBasePrice, setSpinBasePrice] = useState(10);
  const [spinBatchCount, setSpinBatchCount] = useState(30);
  const [freeCount, setFreeCount] = useState<number>(0);
  const [token, setToken] = useState('');

  const onRefreshSpinConfig = () => {
    if (globalStore.token) {
      postSpinConfig(true).then(data => {
        setFreeCount(data?.myFree || 0);
      });
    }
  };
  const doNotice = () => {
    onRefreshSpinConfig();
  };

  const {renderModal: renderSpin, show: spinShow} = useLuckySpinModal({
    drawImage,
    onNotice: doNotice,
    batchCount: spinBatchCount,
    singleAmount: spinBasePrice,
    freeCount: freeCount,
  });
  useFocusEffect(
    useCallback(() => {
      const tokenSub = globalStore.tokenSubject.subscribe(_token => {
        setToken(_token || '');
        postSpinConfig(!!_token)
          .then(data => {
            setDrawImage(data?.image);
            setSpinBasePrice(data?.singleAmount);
            setSpinBatchCount(data?.batchCount);
            setFreeCount(data?.myFree || 0);
            Image.prefetch(data.image).catch(e => {
              console.log(e);
            });
          })
          .catch(e => {
            console.log(e);
          });
      });
      const doNoticeSub = globalStore.doNotices.subscribe(() => {
        doNotice();
      });
      return () => {
        tokenSub.unsubscribe();
        doNoticeSub.unsubscribe();
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []),
  );

  const renderItem = useCallback(
    (item: any, index: number) => {
      return (
        <Pressable
          key={index}
          onPress={item.jumpHandler}
          style={{
            width: calcActualSize(66),
            // width: '4.125rem',
            // height: 74,
            position: 'relative',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 4,
          }}>
          {item.moduleName === i18n.t('home.label.luckySpin') &&
            !!freeCount &&
            freeCount > 0 && (
              <View
                style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  zIndex: 10,
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: '#DC083B',
                  borderWidth: 1,
                  borderColor: '#fff',
                  justifyContent: 'center',
                  alignItems: 'center',
                  padding: 5,
                }}>
                <Text
                  style={{
                    fontSize: 10,
                    fontFamily: 'din',
                    fontWeight: 'bold',
                    color: '#fff',
                  }}>
                  !
                </Text>
              </View>
            )}
          {item.type && item.type === 'get-200' ? (
            <div className="p-0 size-[3.5rem] bg-white rounded-full flex items-center justify-center shadow-sm">
              <img
                className="size-[3rem]"
                src={require('@/assets/icons/home/get-200.png')}
                alt="get-200"
              />
            </div>
          ) : (
            <LazyImage
              src={item.bgImgUrl}
              width={size.computed60}
              height={size.computed60}
              fallback={<div className="size-full bg-image" />}
              // occupapncy="transparent"
            />
          )}
          <span className="text-center font-medium text-[0.75rem] font-weight-500 font-inter text-t1 tracking-tight">
            {item.moduleName}
          </span>
          {/* <Text
            style={{
              textAlign: 'center',
              fontSize: 12,
              textTransform: 'capitalize',
              fontWeight: '500',
              fontFamily: 'inter',
              color: 'var(--T1)',
            }}>
            {item.moduleName}
          </Text> */}
        </Pressable>
      );
    },
    [calcActualSize, freeCount, i18n, size.computed60],
  );

  return (
    //  pr-2
    <div className="pt-2  pb-5">
      <div className="flex flex-row gap-1 items-center overflow-x-auto hide-scrollbar pl-2 pr-2">
        {list.map((item, index) => (
          <div key={index} style={{width: calcActualSize(66)}}>
            {renderItem(item, index)}
          </div>
        ))}
      </div>
      {/* <Swiper
        slidesPerView={'auto'}
        spaceBetween={calcActualSize(4)}
        className="w-full">
        {list.map((item, index) => (
          <SwiperSlide key={index} style={{width: calcActualSize(66)}}>
            {renderItem(item, index)}
          </SwiperSlide>
        ))}
      </Swiper> */}
      {renderSpin}
    </div>
  );
};

export default HomeGoldArea;
